import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";
import PakAffan from '/Images/PakAffan.svg';
import PakAde from '/Images/PakAde.svg';
import PakDennis from '/Images/PakDennis.svg';
import PakEddy from '/Images/PakEddy.svg';
import PakEric from '/Images/PakEric.svg';

const TeamSection = () => {
  const [activeTab, setActiveTab] = useState("Board of Director");
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    section: {
      padding: isMobile ? "40px 10px" : "80px 20px",
      backgroundColor: "#E0DCD9",
      textAlign: "center",
    },
    title: {
      fontSize: isMobile ? "30px" : "40px",
      fontWeight: "bold",
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      marginBottom: "20px",
    },
    description: {
      fontSize: isMobile ? "0.875rem" : "1rem",
      color: "#636363",
      maxWidth: "1000px",
      minHeight: "80px",
      margin: "0 auto 30px",
      lineHeight: "1.6",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      marginBottom: "30px",
      flexDirection: "row", // Tetap horizontal dalam semua ukuran layar
    },
    button: {
      padding: isMobile ? "8px 16px" : "10px 20px",
      borderRadius: "10px",
      border: "2px solid #2D669B",
      cursor: "pointer",
      fontSize: "1rem",
      color: "#214D73",
      backgroundColor: "#E0DCD9",
      transition: "all 0.3s ease",
      width: isMobile ? "100%" : "auto",
    },
    activeButton: {
      backgroundImage: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)", // Use backgroundImage for gradients
      color: "#F4E37B",
    }
,    
    inactiveButton: {
      backgroundColor: "#E0DCD9",
      color: "#214D73",
    },
    cardContainer: {
      display: "flex",
      justifyContent: "center",
      gap: isMobile ? "20px" : "83px",
      flexWrap: "wrap",
      marginTop: "30px",
    },
    card: {
      width: isMobile ? "150px" : "200px",
      textAlign: "center",
    },
    image: {
      width: isMobile ? "120px" : "180px",
      height: isMobile ? "120px" : "180px",
      borderRadius: "50%",
      marginBottom: "10px",
    },
    name: {
      fontSize: isMobile ? "1rem" : "1.2rem",
      fontWeight: "bold",
      color: "#2D669B",
      marginBottom: "5px",
    },
    position: {
      fontSize: isMobile ? "0.875rem" : "1rem",
      color: "#636363",
    },
  };

  const directors = [
    { image: PakAffan, name: "Muhamad Gaffani", position: "President Director" },
    { image: PakAde, name: "Ade Rizki Saputra", position: "Director of Technology" },
    { image: PakDennis, name: "Dennis", position: "Director of Business & Marketing" },
  ];

  const commissioners = [
    { image: PakEddy, name: "Ir. Sutriono Edi MBA", position: "President Commissioner" },
    { image: PakEric, name: "Edric Ng", position: "Commissioner" },
  ];

  return (
    <div style={styles.section}>
      <h2 style={styles.title}>Meet Our Team</h2>
      <p style={styles.description}>
        Our team is a dynamic force, orchestrating excellence through seamless collaboration and a relentless pursuit of innovation.
        At Tennet Team, integrity is not just a promise; it's embedded in our tech-infused DNA, ensuring a transparent and accountable
        approach to custodial solutions.
      </p>

      {/* Button Navigation */}
      <div style={styles.buttonContainer}>
        <button
          style={{
            ...styles.button,
            ...(activeTab === "Board of Director" ? styles.activeButton : styles.inactiveButton),
          }}
          onClick={() => setActiveTab("Board of Director")}
        >
          Board of Director
        </button>
        <button
          style={{
            ...styles.button,
            ...(activeTab === "Board of Commissioner" ? styles.activeButton : styles.inactiveButton),
          }}
          onClick={() => setActiveTab("Board of Commissioner")}
        >
          Board of Commissioner
        </button>
      </div>

      {/* Card Display */}
      <div style={styles.cardContainer}>
        {(activeTab === "Board of Director" ? directors : commissioners).map((member, index) => (
          <div key={index} style={styles.card}>
            <img src={member.image} alt={member.name} style={styles.image} />
            <div style={styles.name}>{member.name}</div>
            <div style={styles.position}>{member.position}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
